export default __webpack_public_path__ + "static/media/andes_a_la_costa_20.fbb08b29.JPG";